import * as actions from "../user.financing/actions";
import * as generalActions from "../actions";

import _ from "underscore";

let initialState = {
  accountInfo: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },

  financings: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
};

const financing = (state = initialState, action) => {
  switch (action.type) {
    // GET FINANCINGS
    case actions.USER_FINANCINGS_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          fetching: true,
          error: null,
          data: [],
        }),
      });
    case actions.USER_FINANCINGS_LIST_GET_SUCCESS: {
      let data = _.sortBy(action.response, (financing) => {
        return financing.closed;
      });
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          fetching: false,
          fetched: true,
          data,
        }),
      });
    }
    case actions.USER_FINANCINGS_LIST_GET_ERROR:
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          fetching: false,
          error: action.error,
        }),
      });
    case actions.USER_FINANCING_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          table: Object.assign({}, state.financings.table, {
            pagination: Object.assign({}, state.financings.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });
    case actions.USER_FINANCING_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          table: Object.assign({}, state.financings.table, {
            currentFilter: Object.assign(
              {},
              state.financings.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    // Financing actions success
    case actions.USER_FINANCING_PAYOUT_INFO_REQUEST: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsIssued.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsIssued.data[toChangeIndex],
        {},
      );
      toChange.PayoutInfoLoading = true;

      return Object.assign({}, state, {
        financingsIssued: Object.assign({}, state.financingsIssued, {
          data: [
            ...state.financingsIssued.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsIssued.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }
    case actions.USER_FINANCING_PAYOUT_INFO_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financingsIssued.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financingsIssued.data[toChangeIndex],
        {},
      );
      toChange.PayoutInfo = action.response;
      toChange.PayoutInfoLoading = false;

      return Object.assign({}, state, {
        financingsIssued: Object.assign({}, state.financingsIssued, {
          data: [
            ...state.financingsIssued.data.slice(0, toChangeIndex),
            toChange,
            ...state.financingsIssued.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }
    case actions.USER_FINANCING_CLOSE_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = false;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }
    case actions.USER_FINANCING_OPEN_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Open = true;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.USER_FINANCING_UNPUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Published = false;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.USER_FINANCING_PUBLISH_SUCCESS: {
      let id = action.dataSent.FinancingId;
      let toChangeIndex = _.findIndex(state.financings.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.financings.data[toChangeIndex],
        {},
      );
      toChange.Published = true;

      return Object.assign({}, state, {
        financings: Object.assign({}, state.financings, {
          data: [
            ...state.financings.data.slice(0, toChangeIndex),
            toChange,
            ...state.financings.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    // Fetching additional account infos
    case generalActions.FINANCING_BOOKING_ACCOUNT_INFO_REQUEST:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          fetching: true,
          fetched: false,
        }),
      });
    case generalActions.FINANCING_BOOKING_ACCOUNT_INFO_SUCCESS:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          data: [...state.accountInfo.data, action.response],
          fetching: false,
          fetched: true,
        }),
      });
    case generalActions.FINANCING_BOOKING_ACCOUNT_INFO_ERROR:
      return Object.assign({}, state, {
        accountInfo: Object.assign({}, state.accountInfo, {
          fetching: false,
          error: action.error,
        }),
      });
    default:
      return state;
  }
};

export default financing;
